import React from "react";
import PageHero from "./components/PageHero";
import Trajectory from "./components/Trajectory";
import Statement from "./components/Statement";
import CTA from "./components/CTA";

export default function Sobre() {
  return (
    <main className="sobre">
      <PageHero
        theme="light"
        align="center"
        eyebrow="Institucional"
        title={
          <>
            Excelência técnica e{" "}
            <strong className="page-hero__title-highlight">governança</strong>{" "}
            corporativa
          </>
        }
        text="Atuamos como parceiros estratégicos em inteligência tributária, conformidade fiscal e estruturação legal para garantir a estabilidade e o crescimento previsível de companhias em expansão."
        primaryButton={{ label: "Falar com Consultor", to: "/contato" }}
        secondaryButton={{ label: "Nossos Serviços", to: "/servicos" }}
      />

      <Trajectory />

      <Statement
        eyebrow="Diretriz Corporativa"
        title="Contabilidade especializada no setor, segurança jurídica e eficiência fiscal como pilares inegociáveis."
        text="Mantemos compromisso irrestrito com prazos, conformidade legal e atualização tributária para proteger o patrimônio de nossos parceiros comerciais."
      />

      {/* Reaproveita o CTA (variante "centered" padrão) com o conteúdo do
          segundo bloco desta seção escura */}
      <CTA
        title="Governança contábil para sua expansão"
        text="Agende uma sessão diagnóstica com nossos consultores seniores e descubra como a inteligência fiscal pode impulsionar o seu negócio."
        buttonLabel="Falar com Consultor"
        buttonTo="/contato"
      />
    </main>
  );
}
